import { render, staticRenderFns } from "./bairunCommentTag.vue?vue&type=template&id=1fc99224&scoped=true&"
import script from "./bairunCommentTag.vue?vue&type=script&lang=js&"
export * from "./bairunCommentTag.vue?vue&type=script&lang=js&"
import style0 from "./bairunCommentTag.vue?vue&type=style&index=0&id=1fc99224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc99224",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fc99224')) {
      api.createRecord('1fc99224', component.options)
    } else {
      api.reload('1fc99224', component.options)
    }
    module.hot.accept("./bairunCommentTag.vue?vue&type=template&id=1fc99224&scoped=true&", function () {
      api.rerender('1fc99224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/stationManage/bairunComment/bairunCommentTag.vue"
export default component.exports